import React, {useState} from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";
import Ecommerce from "../../images/services/cto/Ecommerce.svg";
import RealEstate from "../../images/services/cto/RealEstate.svg";
import Gaming from "../../images/services/cto/Gaming.svg";
import Healthcare from "../../images/services/cto/Healthcare.svg";
import Lifestyle from "../../images/services/cto/lifestyle.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Industries(props) {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const getActiveClass = (index, className) =>
        toggleState === index ? className : "";

    return (
        <div className="seriveces_industries p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
                        <div className="example" data-text="We Serve">
                            <h2>Industries We Serve</h2>
                        </div>
                        <p className="strong">TekRevol has expertise in building beacon tech solutions and digital
                            products for these diverse industries.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="deskstop_version">
                        <div className="process_icons">
                            <ul>
                                <li className={`tabs ${getActiveClass(1, "active-tabs")}`}
                                    onClick={() => toggleTab(1)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Healthcare}
                                            effect="blur" alt="Healthcare" className="img-fluid"
                                        />
                                    </div>
                                    Healthcare
                                </li>
                                <li className={`tabs ${getActiveClass(2, "active-tabs")}`}
                                    onClick={() => toggleTab(2)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={RealEstate}
                                            effect="blur" alt="Real Estate" className="img-fluid"
                                        />
                                    </div>
                                    Real Estate
                                </li>

                                <li className={`tabs ${getActiveClass(3, "active-tabs")}`}
                                    onClick={() => toggleTab(3)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Gaming}
                                            effect="blur" alt="Gaming" className="img-fluid"
                                        />
                                    </div>
                                    Gaming
                                </li>
                                <li className={`tabs ${getActiveClass(4, "active-tabs")}`}
                                    onClick={() => toggleTab(4)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Ecommerce}
                                            effect="blur" alt="Ecommerce" className="img-fluid"
                                        />
                                    </div>
                                    Ecommerce
                                </li>
                                <li className={`tabs ${getActiveClass(5, "active-tabs")}`}
                                    onClick={() => toggleTab(5)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Lifestyle}
                                            effect="blur" alt="Lifestyle" className="img-fluid"
                                        />
                                    </div>
                                    Lifestyle
                                </li>

                            </ul>

                            <div className={toggleState === 1 ? 'content d-block' : "content d-none"}>
                                <p>TekRevol can help you identify and capitalize on the unmatchable potential in the
                                    healthcare industry with beacon technology and BLE solutions. Smartwatches, fitness
                                    bands, and other wearable gadgets collecting real-time data about physical movements
                                    use BLE apps because they ensure high-end performance and limited battery
                                    consumption.</p>
                            </div>
                            <div className={toggleState === 2 ? 'content d-block' : "content d-none"}>
                                <p>BLE apps in the real estate sector automate property hunting, especially in location
                                    and navigation-related tasks. They accelerate the attendance rates on in-person and
                                    virtual property tours. TekRevol can help you digitally transform your real estate
                                    business with key automation through beacon technology.</p>
                            </div>
                            <div className={toggleState === 3 ? 'content d-block' : "content d-none"}>
                                <p>TekRevol has witnessed gaming companies yield the benefits of beacon technology as
                                    early adopters. We can help you build and run scalable games on the cloud using BLE
                                    technology, then send out automatic updates to deliver an uninterrupted player
                                    experience to your target audience.</p>
                            </div>
                            <div className={toggleState === 4 ? 'content d-block' : "content d-none"}>
                                <p>With the percentage of shoppers switching to online channels for basics to luxuries,
                                    it requires growing ecommerce and retail companies to make a plunge into beacon tech
                                    to achieve their conversion targets faster. TekRevol can help you create the right
                                    BLE apps for an integrated, uninterrupted in-store shopping experience with
                                    contactless payment systems, in-store navigation, and interactive product
                                    catalogs.</p>
                            </div>
                            <div className={toggleState === 5 ? 'content d-block' : "content d-none"}>
                                <p>BLE apps, combined with Artificial Intelligence and the Internet of Things, set solid
                                    foundations for secure, high-end home automation efforts. With home automation
                                    software, BLE contributes to content creation, product design, and service provision
                                    in the lifestyle and wellness niche. TekRevol can help you digitize home and office
                                    spaces while creating exceptional personalized experiences for your target audience
                                    and customers in the lifestyle niche.</p>
                            </div>

                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="mobile_version">
                        <div className="tekrevol_mobile_accordion_side">
                            <Accordion
                                defaultActiveKey="1">

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Healthcare}
                                            effect="blur" alt="Healthcare" className="img-fluid"
                                        />
                                        Healthcare
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol can help you identify and capitalize on the unmatchable potential in
                                            the healthcare industry with beacon technology and BLE solutions.
                                            Smartwatches, fitness bands, and other wearable gadgets collecting real-time
                                            data about physical movements use BLE apps because they ensure high-end
                                            performance and limited battery consumption.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={RealEstate}
                                            effect="blur" alt="Real Estate" className="img-fluid"
                                        />
                                        Real Estate
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>BLE apps in the real estate sector automate property hunting, especially in
                                            location and navigation-related tasks. They accelerate the attendance rates
                                            on in-person and virtual property tours. TekRevol can help you digitally
                                            transform your real estate business with key automation through beacon
                                            technolog.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Gaming}
                                            effect="blur" alt="Gaming" className="img-fluid"
                                        />
                                        Gaming
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol has witnessed gaming companies yield the benefits of beacon
                                            technology as early adopters. We can help you build and run scalable games
                                            on the cloud using BLE technology, then send out automatic updates to
                                            deliver an uninterrupted player experience to your target audience.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Ecommerce}
                                            effect="blur" alt="Ecommerce" className="img-fluid"
                                        />
                                        Ecommerce
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>With the percentage of shoppers switching to online channels for basics to
                                            luxuries, it requires growing ecommerce and retail companies to make a
                                            plunge into beacon tech to achieve their conversion targets faster. TekRevol
                                            can help you create the right BLE apps for an integrated, uninterrupted
                                            in-store shopping experience with contactless payment systems, in-store
                                            navigation, and interactive product catalogs.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Lifestyle}
                                            effect="blur" alt="Lifestyle" className="img-fluid"
                                        />
                                        Lifestyle
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>BLE apps, combined with Artificial Intelligence and the Internet of Things,
                                            set solid foundations for secure, high-end home automation efforts. With
                                            home automation software, BLE contributes to content creation, product
                                            design, and service provision in the lifestyle and wellness niche. TekRevol
                                            can help you digitize home and office spaces while creating exceptional
                                            personalized experiences for your target audience and customers in the
                                            lifestyle niche.</p>
                                    </Accordion.Body>
                                </Accordion.Item>

                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Industries;